import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// import { ThemeProvider } from '@mui/material/styles';
// import { createTheme } from '@material-ui/core/styles';
import { TextField, ThemeProvider, createTheme } from '@mui/material';
import { DatePicker, LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { format, subDays, subYears } from 'date-fns';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import countryJson from '../DATA_SET/countries.json';
import DOBcalc from './DOBcalc';
import PassportInfo from './PassportInfo';
const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});
const BookingForm = ({ is_international, person_type, passenger, idx, handleChange }) => {
    const [TITLE, setTITLE] = React.useState(-1);
    // Form Validation
    const titleLOV = ['', "Mr", "Mstr", "Mrs", "Miss"];
    const paxTypeLOV = ['', 'Adult', 'Children', 'Infant']
    const gender = ['', 'Male', 'Female']
    const [C_DOB, setC_DOB] = useState(subYears(new Date(), passenger?.pax_type == 1 ? 12 : passenger.pax_type == 2 ? 2 : 0));
    const [ageYears, setAgeYears] = useState(passenger?.age_years ?? null);
    const [ageDetail, setAgeDetail] = useState(null)

    useEffect(() => {
        if (passenger?.date_of_birth) {
            const dob = dayjs(passenger.date_of_birth)
            const now = dayjs()
            const years = Math.max(0, now.diff(dob, 'year'))
            const afterYears = dob.add(years, 'year')
            const months = Math.max(0, now.diff(afterYears, 'month'))
            const afterMonths = afterYears.add(months, 'month')
            const days = Math.max(0, now.diff(afterMonths, 'day'))
            setAgeYears(years)
            setAgeDetail(`${years}y ${months}m ${days}d`)
        } else {
            setAgeYears(null)
            setAgeDetail(null)
        }
    }, [passenger?.date_of_birth])

    const TitleHandleChange = (value) => {
        setTITLE(value);
    };

    console.log(person_type)
    console.log("is_international", is_international)

    return (
        <div>

            <div className="Layer_Box_Two "  >
                <div className="box form_box_common mb-3 pb-0">
                    <div className="d-flex justify-content-between">
                        <div className="col-auto">
                            <h5 className='mb-0'>
                                Passenger {idx + 1}
                                {/* &#160; {props.formIndex + 1} */}
                            </h5>
                        </div>
                        <div className="col-auto">
                            <h5 className='mb-0'>
                                {paxTypeLOV[Math.max(passenger?.pax_type, 0)]}
                                {ageDetail != null && <small className='ms-2 text-info'>{`(${ageDetail})`}</small>}
                            </h5>
                        </div>
                    </div>
                    <hr className='my-2' />
                    <ThemeProvider theme={darkTheme}>
                        <div className="row">
                            <div className="col-md-2 mb-3">
                                <FormControl fullWidth>
                                    <div className='label' >Title</div>
                                    <Select
                                        value={passenger.title}
                                        onChange={(e) => {
                                            console.log("Changing", e.target.value);

                                            // const titleLOV = ['', "Mr", "Mstr", "Mrs", "Miss"];

                                            handleChange(idx, {
                                                ...passenger,
                                                title: e.target.value,
                                                gender: e.target.value == 'Mr' ? 1 : e.target.value == 'Mstr' ? 1 : e.target.value == 'Mrs' ? 2 : e.target.value == 'Miss' ? 2 : 0
                                            })
                                        }}
                                        style={{ height: '3rem' }}
                                    >
                                        {titleLOV.map((e, i) => <MenuItem key={i} value={e}  >{e || 'Select'}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-5 mb-3">
                                <FormControl fullWidth>
                                    <div className='label' >First name & Middle name</div>
                                    <TextField
                                        InputProps={{ sx: { height: '3rem' } }}
                                        value={passenger.first_name}
                                        variant="outlined" onChange={(e) => {
                                            handleChange(idx, {
                                                ...passenger,
                                                first_name: e.target.value
                                            })
                                            // setPASSANGER_DETAILS({ ...PASSANGER_DETAILS, first_name: e.target.value })
                                        }} />
                                </FormControl>
                            </div>
                            <div className="col-md-5 mb-3">
                                <FormControl fullWidth>
                                    <div className='label' >Last name</div>
                                    <TextField
                                        InputProps={{ sx: { height: '3rem' } }}
                                        value={passenger.last_name}
                                        variant="outlined" onChange={(e) => {
                                            handleChange(idx, {
                                                ...passenger,
                                                last_name: e.target.value
                                            })
                                            //setPASSANGER_DETAILS({ ...PASSANGER_DETAILS, last_name: e.target.value }) 
                                        }} />
                                </FormControl>
                            </div>
                            <div className="col-12 col-xl-6 mb-3">
                                <div className='label' >Date of birth (DD-MM-YYYY)</div>
                                <DOBcalc
                                    value={passenger?.date_of_birth || undefined}
                                    pax_type={passenger?.pax_type}
                                    required
                                    onChange={(payload) => {
                                        // payload -> { day, month, year, iso, valid, ageYears }
                                        const age = typeof payload.ageYears !== 'undefined' ? payload.ageYears : null;
                                        setAgeYears(age);
                                        // keep DatePicker in sync as well
                                        setC_DOB(payload.iso ? new Date(payload.iso) : null);
                                        handleChange(idx, {
                                            ...passenger,
                                            date_of_birth: payload.iso || null,
                                            age_years: age
                                        });
                                    }}
                                />
                            </div>

                            {/**
                             * 0-2: Infant - Max Date -> Current Date, Min Date - current - 2y
                             * 2 - 12 : Child: Max Date -> current date - 2y, Min - current - 12y
                             * 12+ : Adult: Max date: current date - 12y, min date - current date - 100y
                             */}


                            {person_type === "Armed Forces" &&
                                <div className="col-md-3 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >Defence  ID</div>
                                        <TextField
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={passenger?.document_number}
                                            variant="outlined" onChange={(e) => {
                                                handleChange(idx, {
                                                    ...passenger,
                                                    document_number: e.target.value,
                                                    document_type: "DefenceId"
                                                })
                                                //setPASSANGER_DETAILS({ ...PASSANGER_DETAILS, last_name: e.target.value }) 
                                            }} />
                                    </FormControl>
                                </div>}
                            {person_type === "Student Fares" &&
                                <div className="col-md-6 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >Student ID</div>
                                        <TextField
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={passenger?.document_number}
                                            variant="outlined" onChange={(e) => {
                                                handleChange(idx, {
                                                    ...passenger,
                                                    document_number: e.target.value,
                                                    document_type: "StudentId"
                                                })
                                                //setPASSANGER_DETAILS({ ...PASSANGER_DETAILS, last_name: e.target.value }) 
                                            }} />
                                    </FormControl>
                                </div>}
                            {is_international &&
                                <div className="col-md-12 mb-3">
                                   

                                    <PassportInfo
                                        value={{
                                            passport_number: passenger?.passport_number || '',
                                            passport_issue_country: passenger?.passport_issue_country || '',
                                            passport_expiry: passenger?.passport_expiry || ''
                                        }}
                                        onChange={(payload) => {
                                            // payload: { passport_number, passport_issue_country, passport_expiry, valid }
                                            handleChange(idx, {
                                                ...passenger,
                                                passport_number: payload.passport_number || null,
                                                passport_issue_country: payload.passport_issue_country || null,
                                                passport_expiry: payload.passport_expiry || null
                                            })
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </ThemeProvider>
                </div>
            </div>



        </div>
    );
}

export default BookingForm;
